import React from "react";
import { Text, Group, Box, Avatar } from '@mantine/core';
import { IconMessageChatbot } from '@tabler/icons-react';

import { sqlDateToHumanDate } from "../../utils/globalFunctions";

const LastComment = ({ fnFeedback, stateData }) => {
  const isSetData = Array.isArray(stateData) && (stateData.length > 0);

  return (
    <React.Fragment>
      <Box
        p='xs'
        sx={(tema) => ({
          borderRadius: tema.radius.md,
          backgroundColor: tema.colorScheme === 'light' ? (isSetData ? tema.fn.rgba(tema.colors.green[6], 0.2) : tema.fn.rgba(tema.colors.gray[6], 0.1)) : (isSetData ? tema.fn.rgba(tema.colors.green[4], 0.15) : tema.fn.rgba(tema.colors.dark[3], 0.3)),
          '&:hover': {
            backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.green[5], 0.3) : tema.fn.rgba(tema.colors.green[7], 0.2),
          }
        })}

        onClick={(e) => fnFeedback(e)}
      >
        <Group noWrap align='center'>
          <Box>
            {Array.isArray(stateData) && (stateData.length > 0) ?
              <Avatar
                variant="filled"
                radius="xl"
                size='1.35rem'

                styles={(tema) => ({
                  placeholder: {
                    backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.green[8], 0.7) : tema.fn.rgba(tema.colors.green[8], 0.4),
                    fontWeight: 'normal'
                  }
                })}
              >
                {stateData.length}
              </Avatar>
              :
              <IconMessageChatbot size={20} stroke={1.5} />
            }
          </Box>

          {Array.isArray(stateData) && (stateData.length > 0) ?
            <Box>
              <Text size='xs' lineClamp={1}>
                {stateData[0].user_name_created} - {sqlDateToHumanDate({
                  stateDate: stateData[0].date_created,
                  stateWithTime: true,
                  stateLang: 'id',
                  stateIsShort: true,
                  stateDay: false,
                  stateDefaultValue: ' - ',
                  stateDateType: 'day',
                  stateWithSecond: false
                })}
              </Text>

              <Text
                size='xs'
                color='dimmed'
                lineClamp={1}
                sx={{ wordBreak: 'break-word' }}
              >
                {stateData[0].message}
              </Text>
            </Box>
            :
            <Box>
              <Text size='xs' lineClamp={1}>
                Feedback
              </Text>

              <Text
                size='xs'
                color='dimmed'
                lineClamp={1}
              >
                Belum ada feedback
              </Text>
            </Box>
          }
        </Group>
      </Box>
    </React.Fragment>
  )
}

export default React.memo(LastComment);